import React, { useState } from 'react';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

import { Text18 } from '../../../ui/Text18';
import { Link } from '../../../ui/Link';

const Wrapper = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
  margin-top: 120px;
  position: inherit;
`;

const AcceptWrapper = styled.div<{ expanded: boolean }>`
  transition: height 0.5s;
  height: ${props => props.expanded ? 'auto' : '150px'};
  overflow: hidden;
  flex-direction: row !important;
`;


const AcceptedBackground = styled.div<{ expanded: boolean }>`
  opacity: ${props => props.expanded ? '0' : '1'};
  transition: 0.3s;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  position: relative;
  height: 100px;
  top: -100px;
`;

const AcceptLabel = styled(Text18)`
  margin-bottom: 20px;
`;

const InformationBlock = styled.div``;

const ExpandWrapper = styled.div`
  margin-top: -80px;
  transition: 0.3s;
  width: 200px;
`;

type Props = {
  agreeRules: boolean;
  setAgreeRules: React.Dispatch<React.SetStateAction<boolean>>;
}

const AcceptRules: React.FC<Props> = ({ agreeRules, setAgreeRules }) => {
  const { t } = useTranslation(); 
  const [expanded, setExpanded] = useState(false);
  const handleChangeCheckbox = () => setAgreeRules(prev => !prev);

  return (
    <Wrapper>
      <AcceptWrapper expanded={expanded}>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreeRules}
                onChange={handleChangeCheckbox}
              />
            }
            label={
              <AcceptLabel style={{ fontWeight: 700, marginBottom: 0 }}>
                {t('rules_block_title')}
              </AcceptLabel>
            }
          />
          <InformationBlock>
            <AcceptLabel>
              <ul>
                <ul>
                  <li>{t('rules_block_1')}</li>
                  <li>{t('rules_block_2')}</li>
                  <li>{t('rules_block_3')}</li>
                  <li>{t('rules_block_4')}</li>
                  <li>{t('rules_block_5')}</li>
                  <li>{t('rules_block_6')}</li>
                  <li>{t('rules_block_7')}</li>
                </ul>
                {t('rules_block_8')}
              </ul>
            </AcceptLabel>
            <AcceptLabel>{t('rules_block_9')}</AcceptLabel>
            <AcceptLabel>{t('rules_block_10')}</AcceptLabel>
          </InformationBlock>
        </FormGroup>
      </AcceptWrapper>
      <AcceptedBackground expanded={expanded} />
      <ExpandWrapper>
        <Link
          style={{ cursor: 'pointer' }}
          onClick={() => setExpanded(!expanded)}
        >
          <Text18>{t(expanded ? 'hide_rules' : 'show_rules')}</Text18>
        </Link>
      </ExpandWrapper>
    </Wrapper>
  );
};

export default AcceptRules;
